import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

type B3ModalElement = HTMLElement & { open?: boolean };

export const PROJECT_VALIDATION_REJECT_COMMENT_MAX_LENGTH = 100;

@Component({
  standalone: false,
  selector: 'app-project-validation-reject-modal',
  templateUrl: './project-validation-reject-modal.component.html',
  styleUrls: ['./project-validation-reject-modal.component.scss'],
})
export class ProjectValidationRejectModalComponent implements OnChanges {
  @ViewChild('rejectStartModal') rejectStartModal?: ElementRef<B3ModalElement>;

  @Input() open = false;
  @Input() projectName = '';

  @Output() closed = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<string>();

  projectNameValue = '';
  comment = '';
  readonly commentMaxLength = PROJECT_VALIDATION_REJECT_COMMENT_MAX_LENGTH;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectName']) {
      this.projectNameValue = this.projectName;
    }

    if (changes['open'] && !this.open) {
      this.resetForm();
    }
  }

  get canConfirm(): boolean {
    return this.comment.trim().length > 0;
  }

  onCancel(): void {
    this.closeModal(false);
  }

  onConfirm(): void {
    if (!this.canConfirm) {
      return;
    }

    this.confirmed.emit(this.comment.trim());
    this.closeModal(true);
  }

  onModalDismiss(): void {
    this.closeModal(false);
  }

  onCommentChange(value: string): void {
    if (value.length <= this.commentMaxLength) {
      return;
    }

    this.comment = value.slice(0, this.commentMaxLength);
  }

  private closeModal(confirmed: boolean): void {
    const modalHost = this.rejectStartModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });

    if (!confirmed) {
      this.resetForm();
    }

    this.closed.emit(confirmed);
  }

  private resetForm(): void {
    this.comment = '';
  }
}
